export const iconFontAwesomeMathematicsSquareXmark = (
	<i className="fa-solid fa-square-xmark"></i>
);
